import { useMutation } from '@tanstack/react-query';
import { resumeSubscription } from '../../services/subscriptions';
import useGetSubscription from './useGetSubscription';
import { ROUTES } from '../../constants/global';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

interface ResumeSubscriptionOptions {
  onError?: () => void | Promise<void>;
}

function useResumeSubscription({ onError }: ResumeSubscriptionOptions = {}) {
  const { user } = useUser<LoadedUser>();
  const { data: { subscription } = {} } = useGetSubscription();

  const businessId = user?.business?.id;

  const resumeMutation = useMutation({
    mutationFn: async () => {
      if (!subscription || !businessId) return false;

      const { success } =
        (await resumeSubscription(subscription.id, businessId)) || {};
      if (!success) throw new Error('Cannot resume subscription');

      return success;
    },
    onSuccess: success => {
      if (success) {
        window.location.href = `${ROUTES.subscription}?success=true&method=resume`;
      }
    },
    onError,
  });

  return {
    resumeMutation,
    isPending: resumeMutation.isPending,
    isSuccess: resumeMutation.isSuccess,
  };
}

export default useResumeSubscription;
